module.exports = __webpack_public_path__ + "media/images/icons/icon_arrow_up_blue-7114363910260dc84d9b52ef2bb9c57a.svg";